export class RedisSource {
  static Internal = 1;
  static External = 2;
}